import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditProjectStoryForm} from '../../model';
import {DatePicker} from '@gravity-ui/date-components';
import styles from './EditProjectStoryModal.module.scss';
import {Text} from '@gravity-ui/uikit';

interface EditProjectStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  storyId: string | null;
  story?: any; // ProjectStoryModel
}

const FORMAT = 'DD.MM.YYYY';

export const EditProjectStoryModal = ({open, setOpen, storyId, story}: EditProjectStoryModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleDateChange,
    isLoading,
    submitError,
    resetForm,
    submitForm,
  } = useEditProjectStoryForm({storyId, setOpen, story});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Новость проекта',
    title: 'Ошибка при редактировании новости проекта',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать новость проекта'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Заголовок новости"
          placeholder="Заголовок новости"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title ? String(errors.title) : undefined}
        />
        <div className={styles.datePicker}>
          <Text variant="subheader-1" className={styles.label}>
            Дата новости<span style={{color: 'red'}}>*</span>
          </Text>
          <DatePicker
            className={styles.datePickerInput}
            onUpdate={handleDateChange}
            size="xl"
            value={values.date}
            placeholder="Выберите дату"
            format={FORMAT}
          />
        </div>
        <FormInput
          label="Приоритет"
          placeholder="Приоритет"
          name="priority"
          type="number"
          value={values.priority.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.priority && errors.priority ? String(errors.priority) : undefined}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
